import CreatingProfileScreen from "./CreatingProfileScreen";

export default CreatingProfileScreen;
